<template>
  <flow-block-container
    @remove="$emit('remove')"
    @change-time="$emit('change-time', $event)"
    @lock-time="$emit('lock-time', $event)"
    :show-connection="showConnection"
    :item="value">

    FIXED TIME EVENT
    <h3>
      <inline-editable-text
      @change="onUpdate({ title: $event })"
      :value="item.title"
      :inline="true"
      :reset-on-update="false"
      :reset-on-cancel="false"
      :lost-focus-is-update="false"
      :is-editable="isEditable"
      />
    </h3>
  </flow-block-container>
</template>

<script>
import FlowBlockContainer from './FlowBlockContainer'

export default {
  props: {
    value: {},
    showConnection: { default: true },
    isEditable: { default: true }
  },
  data: () => ({
    item: {}
  }),
  watch: {
    value: {
      handler(newValue) {
        this.item = newValue;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
  },
  components: {
    FlowBlockContainer
  }
};
</script>
